import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Form from '@careers-wales/react-components/dist/components/forms/Form.js';
import FormHeader from '@careers-wales/react-components/dist/components/forms/FormHeader.js';
import Textfield from '@careers-wales/react-components/dist/components/forms/TextField/TextField.js';
import FormFooter from '@careers-wales/react-components/dist/components/forms/FormFooter.js';
import SummaryErrors from '@careers-wales/react-components/dist/components/forms/SummaryErrors/SummaryErrors.js';
import Button from '@careers-wales/react-components/dist/components/buttons/Button/Button.js';
import validate from 'validate.js';
import moment from 'moment';
import constraints from '../contraints';

function SearchForm({ setFrom: setFromProp, setTo: setToProp }) {
  const { t } = useTranslation();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [errors, setErrors] = useState({});

  validate.extend(validate.validators.datetime, {
    parse: (value) => {
      return moment.utc(value, 'DD/MM/YYYY');
    },
    format: (value, options) => {
      return moment.utc(value, 'DD/MM/YYYY').format(options.dateOnly ? 'DD/MM/YYYY' : 'DD/MM/YYYY hh:mm:ss');
    }
  });

  function handleReset() {
    setFromProp('');
    setToProp('');
    setFrom('');
    setTo('');
    setErrors({});
  }

  function handleSubmit() {
    const errors = validate({ from, to }, constraints(), { fullMessages: false });

    setErrors(errors || {});

    if (!errors) {
      setFromProp(from);
      setToProp(to);
    }
  }

  return (
    <Form theme={['no-padding', 'no-background', 'on-colour', 'inline-groups', 'inline-footer']}>
      <FormHeader introduction={'<strong>' + t('view.landing.introduction') + '</strong>'} />

      <SummaryErrors errors={errors} />

      <Textfield
        label={t('components.search.from.label')}
        id={'from'}
        name={'from'}
        value={from}
        describedBy={'fromDescription'}
        onChange={setFrom}
        descriptionAfter={t('components.search.from.description')}
      />

      <Textfield
        label={t('components.search.to.label')}
        id={'to'}
        name={'to'}
        value={to}
        describedBy={'toDescription'}
        onChange={setTo}
        descriptionAfter={t('components.search.to.description')}
      />

      <FormFooter>
        <Button className={['form__button-submit']} onPress={handleSubmit} ariaLabel={t('styleguide:forms.search')}>
          {t('styleguide:forms.search')}
        </Button>

        <Button type={'reset'} theme={['secondary']} onClick={handleReset} ariaLabel={t('styleguide:forms.clearAll')}>
          {t('styleguide:forms.clearAll')}
        </Button>
      </FormFooter>
    </Form>
  );
}

export default SearchForm;
